import { render, staticRenderFns } from "./AdminTranscodingOutputs.vue?vue&type=template&id=3fff8f9b"
import script from "./AdminTranscodingOutputs.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminTranscodingOutputs.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports